import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a69f383"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "container-form pt-32" }
const _hoisted_3 = { class: "h6 title mb-24" }
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { class: "scroll-component-container mb-16" }
const _hoisted_6 = { class: "scroll-component" }
const _hoisted_7 = { class: "rgpd-content" }
const _hoisted_8 = { class: "form-check mb-16 text-primary" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = {
  class: "form-check-label ms-8",
  for: "acceptRGPD"
}
const _hoisted_11 = {
  href: "https://proage.es/politica-privacidad/",
  target: "_blank"
}
const _hoisted_12 = { class: "invalid-feedback text-danger mb-0" }
const _hoisted_13 = { class: "form-check mb-32 text-primary" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = {
  class: "form-check-label ms-8",
  for: "acceptOtherConditions"
}
const _hoisted_16 = { class: "invalid-feedback text-danger mb-0" }
const _hoisted_17 = { class: "form-actions text-center text-md-end" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right-long me-8",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (!!_ctx.token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.message), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Política de protección de datos')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(// eslint-disable-next-line max-len
                _ctx.$t('Proage by LFL, S.L. le informa que va a tratar sus datos personales con la finalised de prestar los servicios contratados y/o enviar comunicaciones comerciales. La base jurídica es la ejecución de un contrato de prestación de servicios y el interés legítimo de Proage; tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional, que puede consultar en nuestra web.')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-check-input", {'is-invalid': !!_ctx.errors.acceptRGPD}]),
                type: "checkbox",
                name: "acceptRGPD",
                id: "acceptRGPD",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.acceptRGPD) = $event))
              }, null, 2), [
                [_vModelCheckbox, _ctx.acceptRGPD]
              ]),
              _createElementVNode("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t('He leído y acepto la')) + " ", 1),
                _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('Política de Privacidad')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('de Proage')) + ". ", 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errors.acceptRGPD), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-check-input", {'is-invalid': !!_ctx.errors.acceptOtherConditions}]),
                type: "checkbox",
                name: "acceptOtherConditions",
                id: "acceptOtherConditions",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.acceptOtherConditions) = $event))
              }, null, 2), [
                [_vModelCheckbox, _ctx.acceptOtherConditions]
              ]),
              _createElementVNode("label", _hoisted_15, _toDisplayString(// eslint-disable-next-line max-len
              _ctx.$t('Consiento de forma expresa la cesión de mis datos personales al médico asignado por Proage para mi tratamiento.')), 1)
            ]),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.errors.acceptOtherConditions), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_button, {
              variant: "secondary",
              class: "btn-icon",
              "aria-label": _ctx.$t('Continuar'),
              disabled: !_ctx.meta.valid || _ctx.accepted,
              onClick: _ctx.agreeRGPD
            }, {
              default: _withCtx(() => [
                _hoisted_18,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Continuar')), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}